import styled from 'styled-components';

export const StagingLoginModalComponentContainer = styled.div`
    padding: 40px;

    .register-link {
        .fakelink {
            margin-left: 0.5rem;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/authentication/staging/StagingLoginModalComponentStyle.js